export default __webpack_public_path__ + "static/media/match-queue-Grey.e97aa1ee.svg";